/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   MDP — Interactions custom
   1. Curseur personnalisé (desktop uniquement)
   2. Scroll reveal
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. CURSEUR CUSTOM
  ---------------------------------------------------------- */
  // Seulement sur les devices avec souris précise (pas tactile)
  if (!window.matchMedia('(pointer: fine)').matches) return;

  // Créer les éléments du curseur
  var cursor    = document.createElement('div');
  var cursorDot = document.createElement('div');
  cursor.className    = 'mdp-cursor';
  cursorDot.className = 'mdp-cursor-dot';
  document.body.appendChild(cursor);
  document.body.appendChild(cursorDot);

  // Position actuelle et cible (pour le lag smooth)
  var mouseX = 0, mouseY = 0;
  var curX   = 0, curY   = 0;

  // Écouter le mouvement de la souris
  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;

    // Le dot suit instantanément
    cursorDot.style.left = mouseX + 'px';
    cursorDot.style.top  = mouseY + 'px';

    // Rendre visible au premier mouvement
    cursor.classList.add('is-visible');
    cursorDot.classList.add('is-visible');
  });

  // Animation fluide du cercle (lag léger)
  function animateCursor() {
    curX += (mouseX - curX) * 0.12;
    curY += (mouseY - curY) * 0.12;
    cursor.style.left = curX + 'px';
    cursor.style.top  = curY + 'px';
    requestAnimationFrame(animateCursor);
  }
  animateCursor();

  // Hover sur éléments interactifs → agrandir le curseur
  var hoverTargets = 'a, button, .button, [role="button"], label, .product-item, .article-item, .promo-block';

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest(hoverTargets)) {
      cursor.classList.add('is-hovering');
      cursorDot.style.opacity = '0.4';
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest(hoverTargets)) {
      cursor.classList.remove('is-hovering');
      cursorDot.style.opacity = '1';
    }
  });

  // Masquer le curseur quand la souris quitte la fenêtre
  document.addEventListener('mouseleave', function () {
    cursor.classList.remove('is-visible');
    cursorDot.classList.remove('is-visible');
  });

  document.addEventListener('mouseenter', function () {
    cursor.classList.add('is-visible');
    cursorDot.classList.add('is-visible');
  });

  /* ----------------------------------------------------------
     2. DARK MODE TOGGLE
  ---------------------------------------------------------- */
  var dmToggle = document.getElementById('mdp-darkmode-toggle');
  var logoImg  = document.querySelector('.header__logo-image');
  var logoSrcLight = logoImg ? logoImg.src : null;
  var logoSrcDark  = logoImg ? logoImg.src.replace(/\/files\//, '/files/').split('?')[0] : null;

  // URL du logo dark mode dans les assets du thème
  var darkLogoUrl = document.querySelector('script[src*="custom.js"]')
    ? document.querySelector('script[src*="custom.js"]').src.replace('custom.js', 'logo-dark-mode.jpg')
    : null;

  function applyLogoMode(isDark) {
    if (!logoImg || !darkLogoUrl) return;
    if (isDark) {
      logoImg.dataset.lightSrc = logoImg.dataset.lightSrc || logoImg.src;
      logoImg.src = darkLogoUrl;
      logoImg.style.filter = 'none';
    } else {
      if (logoImg.dataset.lightSrc) {
        logoImg.src = logoImg.dataset.lightSrc;
      }
      logoImg.style.filter = '';
    }
  }

  // Appliquer au chargement si déjà en dark mode
  if (document.body.classList.contains('dark-mode')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { applyLogoMode(true); });
    } else {
      applyLogoMode(true);
    }
  }

  if (dmToggle) {
    dmToggle.addEventListener('click', function () {
      var isDark = document.body.classList.toggle('dark-mode');
      localStorage.setItem('mdp-dark-mode', isDark ? 'true' : 'false');
      dmToggle.setAttribute('aria-label', isDark ? 'Désactiver le mode sombre' : 'Activer le mode sombre');
      applyLogoMode(isDark);
    });
  }

  /* ----------------------------------------------------------
     3. STICKY HEADER — classe is-scrolled au scroll
  ---------------------------------------------------------- */
  var header = document.querySelector('.header');

  if (header) {
    var onScroll = function () {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------
     3. SCROLL INDICATOR — dans le Liquid, on gère juste le scroll hide
  ---------------------------------------------------------- */
  var scrollIndicator = document.querySelector('.video-hero__scroll-indicator');

  if (scrollIndicator) {
    // Clic → smooth scroll vers la section suivante
    scrollIndicator.addEventListener('click', function () {
      var hero = scrollIndicator.closest('[data-section-type="video-hero"]');
      var next = hero && hero.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Disparaît au scroll
    window.addEventListener('scroll', function hideIt() {
      if (window.scrollY > 80) {
        scrollIndicator.style.opacity = '0';
        scrollIndicator.style.transition = 'opacity 0.4s ease';
        scrollIndicator.style.pointerEvents = 'none';
        window.removeEventListener('scroll', hideIt);
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     4. ADD TO CART — toast de confirmation
  ---------------------------------------------------------- */
  var toast = document.createElement('div');
  toast.className = 'mdp-atc-toast';
  toast.innerHTML = '<div class="mdp-atc-toast__check">✓</div><div class="mdp-atc-toast__text"><span class="mdp-atc-toast__title">Ajouté au panier</span><span class="mdp-atc-toast__sub">Voir votre panier →</span></div>';
  document.body.appendChild(toast);

  var toastTimeout;

  document.addEventListener('product:added', function () {
    clearTimeout(toastTimeout);
    toast.classList.add('is-visible');
    toastTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  });

  toast.addEventListener('click', function () {
    window.location.href = '/cart';
  });
  toast.style.cursor = 'pointer';

  /* ----------------------------------------------------------
     5. SCROLL REVEAL
     Ajoute .mdp-reveal aux blocs principaux, puis observe
  ---------------------------------------------------------- */
  function initScrollReveal() {
    // Sélectionner les éléments à animer
    var revealSelectors = [
      '.product-item',
      '.article-item',
      '.promo-block',
      '.offer-item',
      '.text-with-icons__item',
      '[data-section-type="rich-text"] .container',
      '[data-section-type="image-with-text"] .image-with-text__text-container',
      '[data-section-type="blog-posts"] .block-list__item',
      '[data-section-type="featured-collection"] .section__header',
      '[data-section-type="blog-posts"] .section__header'
    ].join(', ');

    var elements = document.querySelectorAll(revealSelectors);

    elements.forEach(function (el) {
      // Ne pas animer si réduit (accessibilité prefers-reduced-motion)
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      el.classList.add('mdp-reveal');
    });

    // IntersectionObserver
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // une seule fois
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.mdp-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  // Lancer après chargement complet du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  /* ----------------------------------------------------------
     6. SEARCH TYPEWRITER — via placeholder natif (centrage auto)
  ---------------------------------------------------------- */
  function initSearchTypewriter() {
    var input = document.querySelector('.header__search-bar-wrapper .search-bar__input');
    if (!input) return;

    var terms = [
      'Plafonnier design',
      'Plafonnier industriel',
      'Plafonnier bois',
      'Plafonnier LED',
      'Ventilateur de plafond',
      'Plafonnier scandinave',
      'Plafonnier moderne',
      'Plafonnier vintage'
    ];

    var termIndex  = 0;
    var charIndex  = 0;
    var isDeleting = false;
    var timer      = null;
    var isPaused   = false;

    function tick() {
      if (isPaused) return;
      var current = terms[termIndex];

      if (!isDeleting) {
        charIndex++;
        input.setAttribute('placeholder', current.substring(0, charIndex));
        if (charIndex === current.length) {
          isDeleting = true;
          timer = setTimeout(tick, 1800);
          return;
        }
        timer = setTimeout(tick, 95);
      } else {
        charIndex--;
        input.setAttribute('placeholder', current.substring(0, charIndex));
        if (charIndex === 0) {
          isDeleting = false;
          termIndex  = (termIndex + 1) % terms.length;
          timer = setTimeout(tick, 400);
          return;
        }
        timer = setTimeout(tick, 55);
      }
    }

    timer = setTimeout(tick, 800);

    input.addEventListener('focus', function () {
      isPaused = true;
      clearTimeout(timer);
      input.setAttribute('placeholder', 'Rechercher...');
    });

    input.addEventListener('blur', function () {
      if (!input.value.trim()) {
        isPaused = false;
        timer = setTimeout(tick, 400);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchTypewriter);
  } else {
    initSearchTypewriter();
  }

})();